import { render, staticRenderFns } from "./nice-slider.vue?vue&type=template&id=0598abb4&scoped=true"
import script from "./nice-slider.vue?vue&type=script&lang=js"
export * from "./nice-slider.vue?vue&type=script&lang=js"
import style0 from "./nice-slider.vue?vue&type=style&index=0&id=0598abb4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598abb4",
  null
  
)

export default component.exports